export const createPasswordChangeErrorMessage = (passwordErrors: string) => {
  let errorMessage = "Error! This password is: \n";
  if (passwordErrors.includes("This password is entirely numeric.")) {
    errorMessage += "- Entirely numeric\n";
    return "Password is entirely numeric. Enter a stronger password.";
  }
  if (passwordErrors.includes("This password is too common.")) {
    errorMessage += "- Too common\n";
    return "Password is too common. Enter a stronger password.";
  }
  if (passwordErrors.includes("The password is too similar to the email address.")) {
    errorMessage += "- Too similar to your email address\n";
    return "Password is too similar to your email address. Enter a stronger password.";
  }
  errorMessage += "\nCorrect your password and try again.";
  return errorMessage;
};
